import { render, staticRenderFns } from "./pos-specify-badge-modal.vue?vue&type=template&id=1f69d5e3&scoped=true&"
import script from "./pos-specify-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-specify-badge-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f69d5e3",
  null
  
)

export default component.exports